import React, { useCallback, useEffect, useMemo, useRef } from "react";
import { View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Button, Modal, Text } from "@lookiero/sty-psp-ui";
import { style as modalNotificationItemStyle } from "./ModalNotificationItem.style";
const ModalNotificationItem = ({ domain, visible, notification, testID = "modal-notification-item", portalHostName, onRemove, }) => {
    const style = useMemo(() => modalNotificationItemStyle(), []);
    const titleText = useI18nMessage({ domain, id: notification.titleI18nKey });
    const bodyText = useI18nMessage({ domain, id: notification.bodyI18nKey });
    const acceptText = useI18nMessage({ domain, id: notification.acceptI18nKey });
    const modalNotificationClosedRef = useRef(false);
    const handleOnClose = useCallback(() => {
        onRemove(notification.id);
        modalNotificationClosedRef.current = true;
    }, [notification.id, onRemove]);
    useEffect(() => () => {
        if (!modalNotificationClosedRef.current) {
            onRemove(notification.id);
        }
    }, [notification.id, onRemove]);
    return (React.createElement(Modal, { portalHostName: portalHostName, testID: testID, visible: visible, onClose: handleOnClose },
        React.createElement(View, { style: style.modal },
            React.createElement(Text, { level: 3, style: style.title, variant: "heading" }, titleText),
            React.createElement(Text, { level: 3, style: style.description }, bodyText),
            React.createElement(Button, { testID: "modal-notification-button", onPress: handleOnClose }, acceptText))));
};
export { ModalNotificationItem };
